export default "__VITE_ASSET__BPGzczcM__"